import { FC } from 'react';
import parse from 'html-react-parser';
import { createDisplayNotificationDate } from '@monorepo/client-common';
import {
  NotificationName,
  type NotificationResponse,
} from '@monorepo/notification-common';
import { Box, Typography, useTheme } from '@monorepo/nova-ui';
import { useNotifications, useTranslateNotification } from '../../../hooks';

export const NotificationItem: FC<NotificationResponse> = ({
  id,
  type,
  values,
  createdAt,
  seen,
}) => {
  const { handleReadById } = useNotifications();
  const { palette } = useTheme();
  const { translate } = useTranslateNotification();

  const message = translate({ id, type, values, createdAt, seen });
  const dateDisplay = createDisplayNotificationDate(createdAt || new Date());

  const isCreditEvent = type === NotificationName.HubCreditReceived;

  const handleNotificationRead = () => {
    if (!seen) handleReadById(id);
  };

  return (
    <Box
      onClick={handleNotificationRead}
      width="100%"
      paddingY="16px"
      paddingX="8px"
      borderRadius="16px"
      sx={{
        backgroundColor: seen ? undefined : palette.background.paper,
        cursor: seen ? 'default' : 'pointer',
        ...(!seen && {
          '&:hover': { backgroundColor: palette.background.blue },
        }),
      }}
    >
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" gap="8px">
          {!seen && (
            <Box
              flexShrink={0}
              sx={{
                width: 8,
                height: 8,
                backgroundColor: isCreditEvent
                  ? palette.success.main
                  : palette.error.main,
                borderRadius: 999,
              }}
            />
          )}
          <Typography
            fontSize={14}
            fontWeight={!seen ? 600 : 400}
            marginBottom="2px"
            sx={{
              '& a': {
                color: palette.primary.main,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              },
            }}
          >
            {parse(message)}
          </Typography>
        </Box>
        <Typography
          fontSize={12}
          color={palette.text.secondary}
          paddingLeft={!seen ? '16px' : undefined}
        >
          {dateDisplay}
        </Typography>
      </Box>
    </Box>
  );
};
